var render = function render(){var _vm=this,_c=_vm._self._c;return _c('strong',[_c('v-btn',{attrs:{"text":""},on:{"click":_vm.onLocation}},[_vm._v(_vm._s(_vm.city))]),_c('br'),(_vm.phone.length > 0)?_c('v-btn',{attrs:{"text":"","href":_vm.telephoneRef},on:{"click":_vm.onPhone}},[_c('div',{class:_vm.theme + '-accent'},[_vm._v(_vm._s(_vm.phone))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }